import { Component } from '@angular/core';
import { CurrencyPipe } from '@angular/common';


export class SkyNumericDemoComponent { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-numeric-demo',
  template: `<sky-definition-list labelWidth="200px">
  <sky-definition-list-heading>
    This is a sample of numeric formatting.
  </sky-definition-list-heading>
  <sky-definition-list-content>
    <p>
      <sky-definition-list-label>
        1 with zero digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1000 with zero digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1000 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1000 with one digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1000 | skyNumeric}}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1100 with zero digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1100 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1100 with one digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1100 | skyNumeric}}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1500 with zero digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1500 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1500 with one digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1500 | skyNumeric}}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1000000 with any digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1000000 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1000000000 with any digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1000000000 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1000000000000 with any digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1000000000000 | skyNumeric:{digits: 0} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1234000 with 2 digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1234000 | skyNumeric:{digits: 2} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1235000000 with 2 digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1235000000 | skyNumeric:{digits: 2} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1.45 with 1 digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1.45 | skyNumeric}}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1234567 with 1 digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1234567 | skyNumeric}}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        15.50 as US dollar currency with 2 digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{15.50 | skyNumeric:{digits: 2, format: 'currency', iso: 'USD'} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        -15.50 as US dollar currency with 2 digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{-15.50 | skyNumeric:{digits: 2, format: 'currency', iso: 'USD'} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1234567 as Euro currency with 2 digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1234567 | skyNumeric:{digits: 2, format: 'currency', iso: 'EUR'} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1450 as UK Pound currency with 2 digits:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1450 | skyNumeric:{digits: 2, format: 'currency', iso: 'GBP'} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1750 as Hong Kong Dollar currency with 1 digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1750 | skyNumeric:{digits: 1, format: 'currency', iso: 'HKD'} }}
      </sky-definition-list-value>
    </p>
    <p>
      <sky-definition-list-label>
        1234567 as Japanese Yen currency with 3 digit:
      </sky-definition-list-label>
      <sky-definition-list-value>
        {{1234567 | skyNumeric:{digits: 3, format: 'currency', iso: 'JPY'} }}
      </sky-definition-list-value>
    </p>
  </sky-definition-list-content>
</sky-definition-list>
`,
  providers: [CurrencyPipe]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
